import { KeycloakConfig, KeycloakInitOptions } from 'keycloak-js';

export const KEYCLOAK_MIN_VALIDITY = 10;

export const keycloakOptions: KeycloakInitOptions = {
  onLoad: 'login-required',
  checkLoginIframe: false,
};

export const keycloakConfig: KeycloakConfig = {
  realm: __KEYCLOAKREALM__,
  url: __KEYCLOAKURL__,
  clientId: __KEYCLOAKCLIENT__,
};
